<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>商品中心</el-breadcrumb-item>
			<el-breadcrumb-item>产品库商品</el-breadcrumb-item>
		</el-breadcrumb>

		<el-form :inline="true" :model="item" class="search">
			<el-form-item label="商品名称">
				<el-input v-model="item.name" placeholder="请输入商品名称" size="small"></el-input>
			</el-form-item>

			<el-form-item label="商品分类">
				<el-cascader v-model="item.product_category_id" placeholder="请选择"
					:options="optionsProduct" :props="filterProps" clearable></el-cascader>
			</el-form-item>

			<el-form-item>
				<el-button type="primary" @click="submit" size="medium">查询</el-button>
			</el-form-item>
		</el-form>
		<div class="btns">
			<el-button type="danger" size="small" @click="batchUpper">批量上架</el-button>
		</div>
		<!--		:data="list"数据-->
		<el-table :data="list" border @selection-change="handleSelectionChange">
			<el-table-column type="selection" align="center"></el-table-column>
			<!--			这里 prop scope传值-->
			<el-table-column width="60" align="center">
				<template slot-scope="scope">
					{{scope.$index + (page-1) * pageSize + 1}}
				</template>
			</el-table-column>

			<el-table-column prop="name" label="名称"></el-table-column>
			<el-table-column label="商品图片">
				<!--				商品的组件和插槽-->
				<template slot-scope="scope">
					<div style="display: flex; align-items: center;">
						<img :src="scope.row.product_pic_main" height="30" style="display: flex; margin-right: 5px;" />
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="price_min" label="成本价"></el-table-column>
			<el-table-column prop="productcategory" label="商品分类">
				<template slot-scope="scope" v-if="scope.row.productcategory">
					{{scope.row.productcategory.name}}
				</template>
			</el-table-column>
			<el-table-column prop="created_date" label="添加时间" align="center"></el-table-column>
			<el-table-column prop="last_modified_date" label="更新时间" align="center"></el-table-column>

			<el-table-column label="操作" width="160" align="center">
				<template slot-scope="scope">
					<!--					传ID过去修改-->
					<el-button size="mini" type="primary" @click="edit(scope.row.id)">查看</el-button>

					<el-button size="mini" type="warning" @click="dialogVisible = true;indexStorePublic = scope.row.id">
						上架</el-button>
					<el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
						<div style="text-align: left;">
							您要上架到分类：<el-cascader v-model="selectStoreCategory" placeholder="请选择" :options="storeProduct"
								:props="filterProps" clearable>
							</el-cascader>
						</div>
						<div class="up-price">
							您要提价的金额：<el-input style="width: 50%;" v-model="upPrice" placeholder="请输入您要提价的金额"></el-input>
						</div>
						<div class="up-price">
							是否开启积分兑换：<el-switch v-model="is_points" active-value="1" inactive-value="0" active-color="#13ce66" inactive-color="#cccccc">
							</el-switch>
						</div>
						<span slot="footer" class="dialog-footer">
							<el-button @click="dialogVisible = false">取 消</el-button>
							<el-button type="primary" @click="changeMarkeOn">确 定</el-button>
						</span>
					</el-dialog>

				</template>
			</el-table-column>
		</el-table>
		<!--		页码-->
		<el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page" :current-page.sync="pageNum"
			:page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
	</div>
</template>
<script>
	export default {
		name: 'Menu',
		data() {
			return {
				// 商品数据
				list: [
				],
				isLoad: false,
				dialogVisible: false,
				// 获取上架商品的ID
				indexStorePublic: -1,
				selectStoreCategory: '',
				pageSize: 20,
				pageNum: 0,
				total: 0,
				page: 1,
				thumb: [],
				number: 0,
				item: {
					product_category_id: 0
				},
				optionsProduct: [],
				storeProduct: [],
				upPrice: '',
				is_points: 0,
				filterProps: {
					value: 'id',
					label: 'name',
					emitPath: false,
					checkStrictly: true
				},
				multipleSelection: [],
				batchUpperVisible: false
			}
		},
		created() {
			this.item = {
				page: this.page,
				limit: this.pageSize,
			}
			this.getData()
			this.loadList()
		},
		methods: {
			getData() {
				// 获取公共商品分类
				this.axios.get('/store/data/getCategoryTreeAdmin', {}).then(res => {
					this.optionsProduct = res.data.list
				})

				// 获取店铺商品分类
				this.axios.get('/store/data/getCategoryTreeStore', {}).then(res => {
					this.storeProduct = res.data.list
				})
			},
			// 获取数据
			loadList() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad

				//	将页码传到/Goods/index
				this.axios.post('/store/product/listSupplierProduct', this.item)
					.then(res => {
						this.isLoad = !this.isLoad
						// 后端返回的商品数据列表
						this.list = res.data.list.data

						this.total = res.data.list.total

					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			},
			// 上架商品
			changeMarkeOn() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad

				let length1 = this.selectStoreCategory.length
				if (this.selectStoreCategory instanceof Array) {
					this.selectStoreCategory = this.selectStoreCategory[length1 - 1]
				}

				let id = []
				if (this.indexStorePublic == 0) {
					for (let key in this.multipleSelection) {
						let item = this.multipleSelection[key]
						id.push(item.id)
					}
					if (id.length == 0) {
						this.$message.error({
							message: '请选择商品',
							showClose: false
						});
						return false;
					}
				}


				this.upPrice = Math.abs(this.upPrice)
				this.axios.post('/store/product/putOnSupplier', {
					id: this.indexStorePublic ? this.indexStorePublic : id,
					price: this.upPrice,
					store_category_id: this.selectStoreCategory,
					is_points: this.is_points
				}).then(res => {

					this.isLoad = !this.isLoad
					this.$message.success({
						message: '操作成功',
						showClose: false
					});
					this.dialogVisible = false
					// 重新获取数据
					this.loadList()
				}).catch(() => {
					console.log(1);
					this.isLoad = !this.isLoad
				})
			},
			// 商品查看
			edit(id) {
				this.$router.push({
					path: '/Goods/supplierEdit.html',
					query: {
						id: id,
						op: 0
					}
				});
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			batchUpper: function () {
				let id = []
				for (let key in this.multipleSelection) {
					let item = this.multipleSelection[key]
					id.push(item.id)
				}
				if (id.length == 0) {
					this.$message.error({
						message: '请选择商品',
						showClose: false
					});
					return false;
				}
				this.indexStorePublic = 0
				this.dialogVisible = true
			},
			// 搜索查询
			submit() {
				this.pageNum = 1
				this.item.page = 1
				this.loadList()
			},
			//sizeReload 共多少条为一页
			sizeReload(val) {
				this.item.pageSize = val
				this.loadList()
			},
			// 前往第几页
			pageReload(val) {
				this.item.page = val
				this.loadList()
			}
		}
	}
</script>
<style scoped>
	.up-price {
		text-align: left;
		margin-top: 20px;
	}
</style>
